// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@media screen and (max-width:949px){
    .edit-widgets-container{
        display: none;
    }
}`, "",{"version":3,"sources":["webpack://./src/styles/Widgets/EditWidget.css"],"names":[],"mappings":"AAAA;IACI;QACI,aAAa;IACjB;AACJ","sourcesContent":["@media screen and (max-width:949px){\r\n    .edit-widgets-container{\r\n        display: none;\r\n    }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
